import React, { CSSProperties } from "react";

export type TSize = {
  min?: string;
  max?: string;
  value?: string;
}

type TColumns = {
  [key: number]: TSize | 'auto';
} | (TSize | 'auto')[]

type TRows = {
  [key: number]: TSize;
} | (TSize | 'auto')[]
// auto:  minmax(min-content, max-content) 自适应
// min-content 列宽等于该列中最长不可断行内容（如单词或图片）的宽度
// max-content 列宽等于该列中最长内容的宽度; 200px fit-content() 限制最大宽度

export enum GridBoxType {
  Form = 'form',
}

export interface GridBoxProps {
  grid: {
    row: number; // 布局的行数
    column: number; // 布局的列数
  };
  gap?: number | string; // 行和列之间的间距
  className?: string;
  style?: CSSProperties;
  columnSizes?: TColumns;
  rowSizes?: TRows;
  type?: GridBoxType; // 作为某些样式的类型, 比如表单
}

export interface ItemProps {
  className?: string;
  style?: CSSProperties;
}


export interface GridBoxComponent extends React.FC<GridBoxProps> {
  Item: React.FC<ItemProps>; // 如果有 Item 的特定 props 就定义 ItemProps
}